import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LaudoUnionService } from 'src/app/services/http/laudo-union.service';
import { LoginService } from 'src/app/services/login.service';
import { first } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
  selector: 'app-relatorio-laudo',
  templateUrl: './relatorio-laudo.component.html',
  styleUrls: ['./relatorio-laudo.component.scss']
})
export class RelatorioLaudoComponent implements OnInit {

  token;
  template;// = jsonRelatorioLaudo.template;
  elements;// = jsonRelatorioLaudo.elements;
  consulta;
  cabecalho;
  exibirHeader;
  urlDownloadFotos;
  urlDownloadPdf;
  openInfo: boolean = false;
  firstTheme;
  unidadeThema;
  app;
  ocultarDoc = false;

  constructor(private loginService: LoginService, private laudoService: LaudoUnionService, private activatedRoute: ActivatedRoute, private modalMsgService: ModalMsgService) { }

  ngOnInit() {
    this.openInfo = false;
    this.token = this.activatedRoute.snapshot.paramMap.get('id');
    this.loginService.getLogIn().pipe(first()).subscribe(v => {
      this.setUrlDownload(v);
      this.ocultarDoc = v.unidade.exibirDocumentoConsultas ? false : true;
    });

    this.laudoService.getRelatorioLaudo(this.token).then(r => {
      this.consulta = r['consulta'];
      this.template = r['template'];
      this.elements = r['elements'];
      this.cabecalho = r['cabecalho'];
      this.template.forEach(t => {
        t.status = t.status || 'theme';
        t.elements = t.elements.filter(e => this.elements[e]).map(e => {
          let element = this.elements[e];
          element.value = element.value == 'SELECIONE' ? 'Não informado' : element.value;
          return element;
        })
      });
      this.getUfMunicipioConsulta(this.consulta, this.elements, this.cabecalho);
      var resumo = this.template.find(t => t.name == 'resumo');
      var resumoLista = this.template.find(t => t.name == 'resumo-lista');
      this.template = this.template.filter(t => t.name != 'resumo' && t.name != 'resumo-lista');
      this.template.splice(1, 0, resumo);
      this.template.splice(2, 0, resumoLista);
      this.template = this.template.filter(t => t);
      this.openInfo = true;
      //qrcode mudado para nova impressão - 10/03/2023
      this.cabecalho.qrcodeUrl = environment.homeUrl + '/laudo/visualizar/' + this.token;
    }).catch(() => {
      this.modalMsgService.openDialog('Erro ao carregar laudo', 'Não foi possível carregar a visualização do laudo.', 'danger');
    });
    this.app = document.getElementsByTagName("app-root");
    this.firstTheme = this.app[0].children[1].className;

  }

  setUrlDownload(user) {
    const id = (user && user.id) ? user.id : '';
    this.urlDownloadFotos = environment.wsUrl + 'laudo/getDownloadFotos/' + this.token + '/' + id;
    this.urlDownloadPdf = environment.wsUrl + 'laudo/relatorioLaudoPdf/' + this.token + '/' + id;
  }

  getUfMunicipioConsulta(consulta, elements, cabecalho) {
    if (consulta) {
      let consultas = consulta['consultas'];
      if (consultas) {
        let c = consultas.find(cs => cs['tipoConsulta'] === 'BIN_ESTADUAL');
        let enterC = false;
        if (c && !enterC) {
          cabecalho['uf'] = c['consulta']['uf']
          cabecalho['municipio'] = c['consulta']['municipio']
          enterC = true;
        }

        c = consultas.find(cs => cs['tipoConsulta'] === 'BIN_FEDERAL');
        if (c && !enterC) {
          cabecalho['uf'] = c['consulta']['uf']
          cabecalho['municipio'] = c['consulta']['municipio']
          enterC = true;
        }

        c = consultas.find(cs => cs['tipoConsulta'] === 'BIN_RF');
        if (c && !enterC) {
          cabecalho['uf'] = c['consulta']['uf']
          cabecalho['municipio'] = c['consulta']['municipio']
          enterC = true;
        }
      }
    } else {
      cabecalho['uf'] = elements.ufVeiculo.value;
      cabecalho['municipio'] = elements.cidade.value;
    }

  }

  downloadPdf() {
    let placa = this.elements.placa.value || this.elements.placaInicio.value;

    this.laudoService.downloadPdf(this.token).then(data => {
      let url = window.URL.createObjectURL(data);
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.href = url;
      a.download = placa ? 'Laudo ' + placa + '.pdf' : 'Laudo.pdf';
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();

    }, error => {
      console.error(error);
    });
  }

  downloadFotos() {
    let placa = this.elements.placa.value;

    if (this.token && this.token != null) {
      this.laudoService.downloadFotos(this.token).then(data => {
        let file = new FileReader();
        file.onload = () => {
          const link = document.createElement('a') as HTMLAnchorElement;
          link.href = file.result as string;
          link.download = placa ? 'Fotos Laudo - ' + placa : 'Laudo Fotos';
          link.addEventListener('click', () => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(file.result as string);
          })
          document.body.appendChild(link);
          link.click();

        }
        file.readAsDataURL(data);
      });
    }

  }

  impressaoJS() {
    this.unidadeThema = this.cabecalho.theme?.toString();
    if (this.unidadeThema != null && this.unidadeThema != undefined) {
      this.app[0].children[1].classList.remove(this.firstTheme);
      this.app[0].children[1].classList.add('theme-' + this.unidadeThema);
    }

    //esconder documento para unidade que nao pode imprimir documento da consulta
    if (this.ocultarDoc) {
      var doc = document.getElementsByClassName('documentoPropBin');
      if (doc.length > 0) {
        doc[0].classList.add('hide-print')
      }
      var docHist = document.getElementById('documentoPropHist')
      if (docHist) {
        docHist.classList.add('hide-print')
      }
    }

    var tempTitle = document.title;
    document.title = 'laudo-' + this.cabecalho.placa || tempTitle;
    window.print();
    document.title = tempTitle;
  }

  @HostListener('window:afterprint')
  onAfterPrint() {

    if (this.ocultarDoc) {
      var doc = document.getElementsByClassName('documentoPropBin');
      if (doc.length > 0) {
        doc[0].classList.remove('hide-print')
      }
      var docHist = document.getElementById('documentoPropHist')
      if (docHist) {
        docHist.classList.remove('hide-print')
      }
    }


    this.app[0].children[1].classList.remove('theme-' + this.unidadeThema);
    this.app[0].children[1].classList.add(this.firstTheme);
  }

  getPdfCompactado() {
    let placa = this.elements.placa.value || this.elements.placaInicio.value;

    this.laudoService.getPdfCompactado(this.token).then(data => {
      let url = window.URL.createObjectURL(data);
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.href = url;
      a.download = placa ? 'Laudo ' + placa + '.pdf' : 'Laudo.pdf';
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    }, error => {
      console.error(error);
    });
  }

  printPdf() {
    // 1️⃣ Abre uma aba em branco imediatamente (sincronamente ao clique)
    const novaAba = window.open('', '_blank');
    // 2️⃣ Exibe uma mensagem temporária (HTML simples)
    if (novaAba) {
      novaAba.document.write(`
      <html>
        <head><title>Gerando Relatório...</title></head>
        <body style="font-family: sans-serif; padding: 2rem;">
          <h2>⏳ Gerando relatório PDF...</h2>
          <p>Isso pode levar até 2 minutos. A janela será atualizada automaticamente.</p>
        </body>
      </html>
    `);
    }
    this.laudoService.getRelatorioPdf(this.urlDownloadPdf).subscribe({
      next: (blob: Blob) => {
        const fileURL = window.URL.createObjectURL(blob);

        // 3️⃣ Se a aba foi aberta com sucesso, redireciona o conteúdo
        if (novaAba) {
          novaAba.location.href = fileURL;
        } else {
          // Fallback: se popup bloqueado mesmo assim
          window.open(fileURL, '_blank');
        }

      },
      error: (err) => {
        console.error('Erro ao baixar PDF:', err);
        if (novaAba) {
          novaAba.document.write('<h3>Erro ao gerar relatório.</h3>');
        }
      },
    });
  }

}
